import { config } from "@/config";

const API_BASE = config.API_BASE_URL;

export async function getAuthorizationUrl(
  params: URLSearchParams,
): Promise<string> {
  const resp = await fetch(
    `${API_BASE}/admin/auth/authorization-url?${params}`,
  );
  if (!resp.ok) {
    throw new Error("Failed to get authorization URL");
  }
  const data = await resp.json();
  return data.authorizationUrl;
}

export interface TokenResponse {
  accessToken: string;
  email: string;
  name: string;
}

export async function exchangeToken(body: {
  code: string;
  nonce: string;
  code_verifier: string;
}): Promise<TokenResponse> {
  const resp = await fetch(`${API_BASE}/admin/auth/token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const data = await resp.json();

  if (!resp.ok) {
    throw new Error(data.error || "Authentication failed");
  }

  return data;
}
